const waitForFileSelectorClose = (): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, 1));
};

export default waitForFileSelectorClose;
